/* global axios */
import ApiClient from '../ApiClient';

// Chequeo de un número antes de la primera conversación por WhatsApp QR (spec polish-1 §3.8).
// Backend: Api::V1::Accounts::Masifi::WhatsappQrNumberChecksController (status: known | no_phone | exists |
// not_on_whatsapp | unknown).
class MasifiWhatsappQrNumberChecksAPI extends ApiClient {
  constructor() {
    super('masifi/whatsapp_qr_number_checks', { accountScoped: true });
  }

  check(inboxId, contactId) {
    return axios.post(this.url, { inbox_id: inboxId, contact_id: contactId });
  }
}

export default new MasifiWhatsappQrNumberChecksAPI();
